import { render, staticRenderFns } from "./LastScan.vue?vue&type=template&id=41448f40&scoped=true"
import script from "./LastScan.vue?vue&type=script&lang=ts"
export * from "./LastScan.vue?vue&type=script&lang=ts"
import style0 from "./LastScan.vue?vue&type=style&index=0&id=41448f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41448f40",
  null
  
)

export default component.exports